import script from "./AssignmentDataLinker.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignmentDataLinker.vue?vue&type=script&setup=true&lang=ts"

import "./AssignmentDataLinker.vue?vue&type=style&index=0&id=f58182c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58182c2"]])

export default __exports__